import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MVHttpInterceptor } from './services/msal/interceptors/mv-http.interceptor.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxsModule } from '@ngxs/store';
import { ConfigurationState } from './store/insight-configuration.state';
import { MvRouteGuardService } from './services/msal/guards/mv-route-guard.service';
import { InsightConfigurationService } from './services/insight-configuration.service';
import { KPIConfigurationState } from './store/kpi-configuration/kpi-configuration.state';
import { PredictiveFailureState } from './store/predictive-failure-configuration/predictive-failure-configuration.state';
import { UnitOfMeasureState } from './store/unit-of-measure/unit-of-measure.state';
import { ThemeSwitchService } from './services/theme/theme-switch.service';
import { EwbConfigurationState } from './store/ewb-configuration/ewb-configuration.state';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NgxsModule.forRoot(
      [ConfigurationState, KPIConfigurationState, PredictiveFailureState, UnitOfMeasureState,EwbConfigurationState], 
      {
        developmentMode: false
      }
    )
  ],
  providers: [
    HttpClientModule,
    MVHttpInterceptor,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MVHttpInterceptor,
      multi: true,
    },
    MvRouteGuardService,
    InsightConfigurationService,
    ThemeSwitchService
  ]
})
export class CoreModule { }
